import type { ReactNode } from 'react';
import clsx from 'clsx';

interface TableFooterProps {
  total: number;
  pagination?: ReactNode;
  className?: string;
}

export function TableFooter({ total, pagination, className }: TableFooterProps): JSX.Element {
  const safeTotal = Math.max(0, Math.floor(total));
  return (
    <div
      className={clsx('flex items-center justify-between px-4', className)}
      style={{
        backgroundColor: 'var(--bui-surface-alt)',
        borderTop: '1px solid var(--bui-divider)',
        minHeight: 36,
      }}
    >
      <span className="text-xs" style={{ color: 'var(--bui-text-secondary)' }}>
        Total items: <strong style={{ color: 'var(--bui-text-primary)' }}>{safeTotal}</strong>
      </span>
      {pagination}
    </div>
  );
}
